import module from 'finanzas/module.js'

const schema = {
  saldo: 'number',
  transito: 'number',
  retenido: 'number',
  cancelado: 'number',
}

function FinancesPosicionbancariaSaldos ($http) {
  this.get = function (fechaCorte, estatusCuenta) {
    return $http.get('/api/bancos/reportes/movimientos', {
      params: {fechaCorte: fechaCorte, estatusCuenta: estatusCuenta},
      schema,
      cache: 'finances',
    })
  }
}

module.service('FinancesPosicionbancariaSaldos', FinancesPosicionbancariaSaldos)



// WEBPACK FOOTER //
// ./src/finanzas/services/Finances/Posicionbancaria/Movimientos.js